<template>
  <div class="subscription-success">
    <div class="row pt-5 pb-5">
      <div class="col-12 col-lg-8 mx-auto">
        <div class="bg-white shadow-sm p-5">
          <LoaderContentEs v-if="isLoading" :welcomeMessage="false" :alignSpinnerTop="true" />

          <div class="d-flex align-items-center justify-content-center" v-if="opportunity && opportunity.subscription_message && opportunity.subscription_message.length > 0">
            <div v-html="opportunity.subscription_message"></div>
          </div>

          <div class="d-flex align-items-center justify-content-center" v-else>
            <progress-check-icon style="font-size:120px;" class="text-blue-ml" />

            <h4 class="m-3 text-muted font-weight-normal">
              <div class="d-flex align-items-center justify-content-center" v-if="opportunity && opportunity.subscription_message && opportunity.subscription_message.length > 0">
                <div v-html="opportunity.subscription_message"></div>
              </div>

              <div v-else>
                {{ username }}, <br />
                su candidatura para <strong v-if="opportunity">{{ opportunity.title }}</strong>
                se realizó con éxito!
              </div>
            </h4>
          </div>

          <div class="text-center my-5" v-if="tests && tests.length > 0">
            <h4>Tienes algunas pruebas pendientes por hacer</h4>
          </div>

          <div class="d-flex align-items-center p-3 bg-light-2 shadow-sm mb-4" v-for="(test, i) in tests" :key="i">
            <file-document-outline-icon class="mr-2" style="font-size:30px;" v-if="test.status == 'pending'" />
            <file-check-outline-icon class="mr-2 text-green-ml" style="font-size:30px;" v-if="test.status == 'finished'" />

            <div class="mr-2">
              <h6>{{ test.name }}</h6>
              <span v-if="test.status == 'pending'">Pendiente</span>
              <span v-if="test.status == 'finished'">Finalizado</span>
            </div>

            <button v-if="test.source == 'primeira_escolha' && test.status == 'pending'"  @click="alertPrimeiraEscolha(test.url)" class="btn btn-blue-ml ml-auto d-flex align-items-center">
              Comenzar <chevron-right-icon class="h3 ml-5 mb-0" />
            </button>

            <button v-if="test.source == 'jobecam' && test.status == 'pending'"  @click="alertJobecam(test.url)" class="btn btn-blue-ml ml-auto d-flex align-items-center">
              Comenzar <chevron-right-icon class="h3 ml-5 mb-0" />
            </button>

            <button v-if="test.source != 'primeira_escolha' && test.source != 'jobecam' && test.status == 'pending'" @click="goToTest(`${test.name}/${test.test_id}`)" class="btn btn-blue-ml ml-auto d-flex align-items-center">
              Comenzar <chevron-right-icon class="h3 ml-5 mb-0" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LoaderContentEs from 'ninenine-white-label/src/components/Loader/LoaderContentEs.vue'
  import ProgressCheckIcon from "vue-material-design-icons/ProgressCheck.vue"
  import AlertCircleIcon from "vue-material-design-icons/AlertCircle.vue";
  import FileAlertIcon from "vue-material-design-icons/FileAlert.vue";
  import FileCheckIcon from "vue-material-design-icons/FileCheck.vue";
  import FileDocumentOutlineIcon from "vue-material-design-icons/FileDocumentOutline.vue";
  import FileCheckOutlineIcon from '@/components/mlIcons/FileCheckOutline';
  import ChevronRightIcon from "vue-material-design-icons/ChevronRight.vue";

  export default {
    name: 'SubscriptionSuccessReturn',

    data() {
      return {
        isLoading: false,
        tests: [],
        opportunity: null,
      }
    },

    computed: {
      opportunityId(){
        const id = this.$route.query.id.match(/\d+/)[0]
        return id
      },

      username() {
        return this.$store.state.user.profile.name.split(' ')[0]
      },

      pageCountry(){
        return this.$route.params.pais;
      }
    },

    components: {
      LoaderContentEs,
      ProgressCheckIcon,
      AlertCircleIcon,
      FileAlertIcon,
      FileCheckIcon,
      FileDocumentOutlineIcon,
      FileCheckOutlineIcon,
      ChevronRightIcon
    },

    beforeDestroy() {
      document.getElementById("someExtraContent").innerHTML = '';
    },

    async mounted() {
      this.isLoading = true

      await this.getOpportunity()

      this.$store.dispatch('tests/subscriptionTests', {
        opportunityId: this.opportunityId,
        finishedTests: false,
        requiredIn: 'thank_you'
      }).then(tests => {
        this.tests = tests.subscriptionTests.json || []
        this.isLoading = false
      })
    },

    methods: {
      async getOpportunity() {
        const get = () => {
          this.$store
            .dispatch("opportunities/getOpportunity", this.opportunityId)
            .then((opportunity) => {
              if (opportunity) {
                this.opportunity = opportunity;
              }
            });
        };

        get();
      },

      alertPrimeiraEscolha(link){
        this.$swal({
          title: 'Atenção',
          text: 'Você será direcionado para o site Primeira Escolha para realizar o teste.',
          type: 'info',
          showCancelButton: true,
          cancelButtonText: 'Fechar',
          confirmButtonText: 'Vamos lá!',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            window.location.href = link
          }
        })
      },

      alertJobecam(link){
        this.$swal({
          title: 'Atenção',
          text: 'Você será direcionado para o site Jobecam para realizar o teste.',
          type: 'info',
          showCancelButton: true,
          cancelButtonText: 'Fechar',
          confirmButtonText: 'Vamos lá!',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            window.location.href = link
          }
        })
      },

      goToTest(testId){
        window.afterTestBackTo = this.$route.fullPath;
        this.$router.push(`vagas/${this.opportunity.id}/inscricao/${ testId }`);
      },
    },

  }
</script>

<style lang="scss">
  .subscription-success {
    min-height: 100vh;
    background-color: #f9f9f9;
  }
</style>
